module.exports = __webpack_public_path__ + "img/mobile-resolutions-short-lived.e20a175f.png";